module.exports = __webpack_public_path__ + "img/arrow-up.948cc0b.svg";